// envConfig.js

const ENV = {
  local: {
    ROOT_URL: 'http://localhost:3000',
    PORT: 4300,
  },
  development: {
    ROOT_URL: 'https://wms-api-dev.warehousenow.in',
    PORT: 4300,
  },
  qa: {
    ROOT_URL: 'https://qa-api.example.com',
    PORT: 4300,
  },
  staging: {
    ROOT_URL: 'https://staging-api.example.com',
    PORT: 4300,
  },
  production: {
    ROOT_URL: 'https://wms-api.warehousenow.in/',
    PORT: 5100,
  },
};

console.log(import.meta.env.MODE);

// Detect current environment using Vite mode
const CURRENT_ENV = import.meta.env.MODE === 'dev' ? 'local' : import.meta.env.MODE; // TODO: ask with nikhil

// Export the config for the current environment
export const config = ENV[CURRENT_ENV];
